import styled from 'styled-components'
import { breakpoints, colors } from '@/styles'
import { Label } from '@/components/text'
import { useAddendumModal } from './context'

const Wrapper = styled.div`
  overflow: ${props => (props.overflow ? props.overflow : 'hidden')};
  min-width: ${props => (props.minWidth ? props.minWidth : '536px')};
  min-height: ${props => (props.minHeight ? props.minHeight : '356px')};
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    min-height: 412px;
  }
`

const Header = styled.div`
  height: 65px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 25px 0;
  flex-shrink: 0;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    height: 60px;
    padding: 5px 20px 0;
  }
`

const ContentWrapper = styled.div`
  max-width: 100vw;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 24px 24px;
  overflow: ${props => (props.overflow ? props.overflow : 'hidden')};

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 16px 24px 24px;
  }
`

const TitleWrapper = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ModalSubtitle = styled(Label)`
  color: ${colors.grey48};
`

const ModalBase = ({
  children,
  leftWidget,
  rightWidget,
  title,
  subtitle,
  minHeight,
  minWidth,
  overflow,
  Icon,
  useContext
}) => {
  const useModal = useContext ? useContext : useAddendumModal
  const { ModalTitle } = useModal()
  return (
    <Wrapper minHeight={minHeight} minWidth={minWidth} overflow={overflow}>
      <ModalTitle>
        <TitleWrapper>
          <Title>
            {Icon && <Icon width={16} />}
            {title}
          </Title>
          {subtitle && <ModalSubtitle fontSize="14px">{subtitle}</ModalSubtitle>}
        </TitleWrapper>
      </ModalTitle>
      {(leftWidget || rightWidget) && (
        <Header>
          {leftWidget}
          {rightWidget}
        </Header>
      )}
      <ContentWrapper overflow={overflow}>{children}</ContentWrapper>
    </Wrapper>
  )
}

export default ModalBase
